import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppBaseComponent } from './app-base.component';

@NgModule({
  declarations: [AppBaseComponent],
  exports: [AppBaseComponent],
  imports: [CommonModule],
  providers: [],
})
export class AppBaseModule {}
